module.exports = __webpack_public_path__ + "img/1.330e68bb.png";